module.exports = __webpack_public_path__ + "img/clear.21e67564.svg";